import cloneDeep from 'lodash/cloneDeep';
import { fillOriginPermission } from '@modules/systemSetting/systemModule/helper';

/**
 * `instanceType` for permission fill — prefer Redux `projectCompanyInfo.instanceType` when available;
 * else read from settings payload (matches flux `getProjectSetting` behavior).
 *
 * @param {object} result — raw GET /project/settings response
 * @returns {string|undefined}
 */
export function getInstanceTypeFromProjectSettings(result) {
  if (!result?.projectInfo) {
    return undefined;
  }
  return (
    result.projectInfo.instanceType ??
    result.projectInfo.intanceType ??
    undefined
  );
}

/**
 * Mirrors flux `getProjectSetting` transforms on `moduleInfo` and `groups`
 * ([projects.js](src/flux/action/projects.js)) so POST bodies match a full save.
 *
 * @param {object} result — raw GET response (mutated copy returned)
 * @param {string} [instanceType] — from `getInstanceTypeFromProjectSettings` or Redux
 * @returns {object|null}
 */
export function normalizeProjectSettingsResponse(result, instanceType) {
  if (!result) {
    return null;
  }
  const data = cloneDeep(result);

  const it = instanceType ?? getInstanceTypeFromProjectSettings(data);

  if (Array.isArray(data.moduleInfo)) {
    data.moduleInfo.forEach((i) => {
      // API may send camelCase `groupPermissions` only; flux used `groupsPermission`.
      i.groupPermissions = i.groupsPermission ?? i.groupPermissions;
      if (Array.isArray(i.groupPermissions)) {
        i.groupPermissions.forEach(
          (j) =>
            (j.groupPermission =
              j.groupPermission?.filter((key) => Boolean(key)) || []),
        );
      }
      fillOriginPermission(i, it);
      Reflect.deleteProperty(i, 'groupsPermission');
      if (i.value === 'insight' && Array.isArray(i.originPermissions)) {
        i.originPermissions = i.originPermissions.filter(
          (item) => item.value !== 'insights',
        );
      }
    });
  }

  if (Array.isArray(data.groups)) {
    data.groups.forEach((g) => {
      if (Array.isArray(g.groupMembers)) {
        g.groupMembers.forEach((member) => {
          if (!member.groupId) {
            member.groupId = g.groupInfo.id;
          }
        });
      }
    });
  }

  return data;
}
